<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Tahun" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Tahun"
                    label="Tahun"
                    :error-messages="errors"
                    placeholder="Tahun"
                    v-model="form.Tahun"
                    hide-details="auto"
                    type="number"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Status Awal" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Status Awal"
                    label="Status Awal"
                    :error-messages="errors"
                    placeholder="Status Awal"
                    v-model="form.StatusAwal"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Status Kini" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Status Kini"
                    label="Status Kini"
                    :error-messages="errors"
                    placeholder="Status Kini"
                    v-model="form.StatusKini"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>

                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Tahun: "",
      StatusAwal: "",
      StatusKini: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app
    })
  },
  watch: {
    "form.Tahun": function(val) {
      this.form.Tahun = parseInt(val);
    }
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/tahun", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/tahun");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Tahun" : "Tahun Baru";
    }
  },
  async mounted() {
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/tahun/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>